export default __webpack_public_path__ + "static/media/white.d551dc22.svg";